/**
 * Click burst effect — PDP only. Spawns emoji images that pop outward
 * from the cursor on click, then fade out. Uses GSAP for animation.
 * Reads emoji URL from product metafield, config from theme settings.
 */
(function () {
  const container = document.querySelector('[data-click-burst]');
  if (!container) return;

  const defaultEmojiUrl = container.dataset.burstEmoji;
  if (!defaultEmojiUrl) return;

  const config = {
    count: parseInt(container.dataset.burstCount, 10) || 10,
    minSize: parseInt(container.dataset.burstMinSize, 10) || 20,
    maxSize: parseInt(container.dataset.burstMaxSize, 10) || 50,
    radius: parseInt(container.dataset.burstRadius, 10) || 1500,
    duration: parseFloat(container.dataset.burstDuration) || 1.0,
    rotation: parseInt(container.dataset.burstRotation, 10) || 120,
    gravity: parseInt(container.dataset.burstGravity, 10) || 30,
    stagger: parseInt(container.dataset.burstStagger, 10) / 1000 || 0.015,
  };

  // Preload default emoji
  const preload = new Image();
  preload.src = defaultEmojiUrl;

  function burst(x, y, emojiUrl = defaultEmojiUrl) {
    if (typeof window.gsap === 'undefined') return;

    for (let i = 0; i < config.count; i++) {
      const img = document.createElement('img');
      img.src = emojiUrl;
      img.setAttribute('aria-hidden', 'true');

      const size = config.minSize + Math.random() * (config.maxSize - config.minSize);
      img.style.cssText = `
        position: fixed;
        left: ${x}px;
        top: ${y}px;
        width: ${size}px;
        height: ${size}px;
        pointer-events: none;
        z-index: 99999;
        object-fit: contain;
        opacity: ${0.6 + Math.random() * 0.4};
      `;

      document.body.appendChild(img);

      const angle = (i / config.count) * Math.PI * 2 + (Math.random() - 0.5) * 0.6;
      const distance = config.radius * (0.7 + Math.random() * 0.3);
      const dx = Math.cos(angle) * distance;
      const dy = Math.sin(angle) * distance + config.gravity + Math.random() * config.gravity;
      const stagger = i * config.stagger;
      const duration = config.duration + Math.random() * (config.duration * 0.5);

      window.gsap.fromTo(img,
        { scale: 0 },
        {
          x: dx,
          y: dy,
          scale: 1,
          rotation: (Math.random() - 0.5) * config.rotation,
          duration,
          delay: stagger,
          ease: 'power2.out',
        }
      );

      window.gsap.to(img, {
        opacity: 0,
        scale: 0.3,
        duration: duration * 0.4,
        delay: stagger + duration * 0.55,
        ease: 'power1.in',
        onComplete: () => img.remove(),
      });
    }
  }

  document.addEventListener('click', (e) => {
    const swatchEl = e.target.closest('[data-burst-emoji]');
    if (swatchEl) {
      // Swatch has its own scent emoji — use it instead of the page-level one
      burst(e.clientX, e.clientY, swatchEl.dataset.burstEmoji);
    } else {
      burst(e.clientX, e.clientY);
    }
  });
})();